import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { ContractorService } from 'src/app/Service/Contractor/Contractor.service';
import { LabService } from 'src/app/Service/Lab/Lab.service';
import { SubjectLetterService } from 'src/app/Service/SubjectLetter/SubjectLetter.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ColleagueDownload',
  templateUrl: './ColleagueDownload.component.html',
  styleUrls: ['./ColleagueDownload.component.scss']
})
export class ColleagueDownloadComponent implements OnInit {
  PrintURl:String=environment.BaseUrl+"ColleaguePrint/Print?id="

  Procssing: boolean = false;
  FormSubmitted: boolean = false;

  constructor(
    private Contractor_Service:ContractorService,
    private Lab_Service: LabService,
    private Calibration_Service: CalibrationService,
    private Alertify_Service: AlertifyService,
    private SubjectLetter_Service: SubjectLetterService,
  ) { }

  ngOnInit() {

    this.ReadData_Contractor()
  }


  //#region Contractor

  Selected_Contractor_Id:String='0'
  Selected_Contractor_Customer_Id:String='0'

  DataList_Contractor:Array<General_Interface>=[]
  ReadData_Contractor(){
    this.Contractor_Service.GetActiveList().subscribe(
      data=>{
        this.DataList_Contractor = data
        this.ReadData_SubjectLetter()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  DataList_Contractor_Customer:Array<General_Interface>=[]
  ReadData_Contractor_Customer(){
    this.Contractor_Service.GetCustomerActiveList(Number(this.Selected_Contractor_Id)).subscribe(
      data => {

        this.PrintURl = environment.BaseUrl + "ColleaguePrint/Print?id3=" + this.SubjectLetter_Id
      + "&id2="+this.Selected_Contractor_Customer_Id
      + "&id="

        this.DataList_Contractor_Customer=data
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion

  ResetForm(){
    this.FormSubmitted=false
    this.Info_Download_List=[]
    this.Info_Download_List_Letter_Id=[]
    this.QRCodeInputDownload.nativeElement['value']=''
  }

  //#region Download
    Info_Download_List: Array<General_Interface> = []
    Info_Download_List_Letter_Id: Array<number> = []

    @ViewChild('QRCodeInputDownload') QRCodeInputDownload: ElementRef;

    QRCodeInputDownload_Enter() {
      this.Get_Calibration_Info_Download(this.QRCodeInputDownload.nativeElement['value'])
    }

    Get_Calibration_Info_Download(QRCodeInput: string) {

      if (!this.Procssing) {
        this.Procssing = true
        this.Calibration_Service.GetInfobyQR(QRCodeInput).subscribe(
          data => {

            this.Procssing = false
            this.QRCodeInputDownload_Esc()

            if (data.id == -1) {
              this.Alertify_Service.ErrorMessage("QR Code اسکن شده معتبر نمی باشد")
            }
            else if (this.Info_Download_Exist(data)) {
              this.Alertify_Service.ErrorMessage("QR Code اسکن شده در لیست موجود است")
            }
            else {
              data.dsc=QRCodeInput
              this.Info_Download_List.push(data)
              this.Alertify_Service.SuccessMessage("اطلاعات دستگاه خوانده شد")
            }

          }, error => {
            this.Procssing = false
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده معتبر نمی باشد")

          }
        )
      }

    }

    QRCodeInputDownload_Esc() {
      this.QRCodeInputDownload.nativeElement['value'] = ''
    }

    Info_Download_Exist(input: General_Interface) {
      for (let item of this.Info_Download_List) {
        if (item.code == input.code) {
          return true
        }
      }
      return false
    }

    Info_Download_Remove(id: number) {
      this.Info_Download_List.splice(id, 1)
      this.Alertify_Service.SuccessMessage("حذف شد")
      this.QRCodeInputDownload.nativeElement.focus();
    }


  QRCodeChangeDownload() {



      this.Procssing = true

      var Code: Array<string> = []
      for (let item of this.Info_Download_List) {
        Code.push(item.dsc)
      }

      var UserDsc: Array<string> = []
      for (let item of this.Info_Download_List) {
        UserDsc.push(item.userDsc)
      }

    this.Lab_Service.PostDownloadHamKar(
      Code,
      UserDsc,
      Number(this.Selected_Contractor_Id),
      Number(this.SubjectLetter_Id),
      Number(this.Selected_Contractor_Customer_Id)).subscribe(
        data => {

          this.Procssing = false
          this.QRCodeInputDownload_Esc()
          this.Info_Download_List = data['device']
          this.Info_Download_List_Letter_Id = data['success']

          this.FormSubmitted=true
          this.Alertify_Service.SuccessMessage("دستگاه ها برای تحویل بررسی شد")

          this.PrintURl=environment.BaseUrl + "ColleaguePrint/Print?id2="+Number(this.Selected_Contractor_Customer_Id)+"&id="

        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }


    //#endregion

  //#region SubjectLetter

  SubjectLetter_Id:string='0'
  DataList_SubjectLetter: Array<General_Interface> = []
  ReadData_SubjectLetter() {
      this.SubjectLetter_Service.GetActiveList().subscribe(
        data => {
          this.DataList_SubjectLetter = data

        }, error => {


        }
      )
  }

  SubjectLetter_Change() {
    this.PrintURl = environment.BaseUrl + "ColleaguePrint/Print?id3=" + this.SubjectLetter_Id
      + "&id2="+this.Selected_Contractor_Customer_Id
      + "&id="
  }

  //#endregion


}
